const share = {
    namespaced: true,
    state: {
        shareInfo: {
            status: null,
            message: '',
            inviteCode: '******',
            invitesShareCount: 0,
            // InvitesActiveUserShareCount:0,
            availableSharePoints: 0,
            userTotalInSharePoints:0,
            availablePurchasePoints: 0,
            pendingPurchasePoints: 0,
            availablePurchasePointsYuan: 0,
            redeemedTrafficPackages: [],
            yesterdayPoints: 0,
            withdrawnPoints:0,
            isSuccess: false,
            share_rebate:[{new_purchase_percent:0,renew_percent:0},{new_purchase_percent:0,renew_percent:0},{new_purchase_percent:0,renew_percent:0}],
            user_name:'',
            withdrawnYuan: 0,
            userAvailablePurchasePointsNoRefundNoPending: 0,
            userAvailablePurchasePointsNoRefundNoPendingYuan:0,
            MaxReferralsOfAvailableGifts: 0,
            extraGiftedPoints: 0,
            sharesThisMonth: {
                total_inactive_invites: 0,
                total_invites: 0,
                total_active_invites: 0
            },
            sharesLastSixMonths: {
                total_inactive_invites: 0,
                total_invites: 0,
                total_active_invites: 0
            },
            currentMonthSharePointsIn:0,
            currentMonthPurchasePointsIn:0,
            sixMonthsSharePointsIn:0,
            sixMonthsPurchasePointsIn:0,
            // share_gifted_points:0
        },
        systemPlans: [] as {
            id: -1,
            title: "",
            description: "",
            product_key: "",
            plan_category: -1,
            plan_time: 0,
            plan_time_obj:{
                days:0,
                hours:0,
                minutes:0
            }
            total_month: 0,
            billed: 0,
            status: -1,
            sorting_order: 0,
            bandwidth_limit: 0,
            extra_bandwidth: 0,
            speed_limit: "0",
            allowed_device_number: 2,
            is_recommended: 0,
            is_offer: 0,
            is_disabled: 0,
            price_coins: 0,
            price_coins_discount: 0
        }[],
        records:{
            status:false,
            message: '',
            isSuccess: false,
            UserPointsProcessesShare:[],
            UserPointsProcessesRedeemShare:[],
            UserPointsProcessesPurchase:[],
            UserPointsProcessesWithdraw:[],
            UserPointsProcessesRedeemPurchase:[],
            UserPointsProcessesPurchasePendding:[],
            UserPointsProcessesPurchaseRefunded:[],
            UserPointsProcessesGifts: [],
            allProcess:[]
        },
        withdrawnHistory:{
            message: '',
            total_records: 0,
            isSuccess: false,
            data:[]
        },
        giftsList:null,
        saveImage:0
    },
    mutations: {
        UPDATE_SHARE_INFO(state, data) {
            state.shareInfo = data
        },
        UPDATE_SYSTEM_PLANS(state,data) {
            state.systemPlans = data
        },
        UPDATE_RECORDS(state,data) {
            state.records = data
        },

        UPDATE_WITHDRAWN_HISTORY(state,data) {
            state.withdrawnHistory = data
        },
        UPDATE_GIFTS_LIST(state, data) {
            state.giftsList = data
        },

        UPDATE_STATE_GIFT(state,data) {
            for(let i=0; i<state.giftsList.length ; i++) {
                if(state.giftsList[i].id === data) {
                    state.giftsList[i].disabled = true
                    state.giftsList[i].not_given_before = false
                    state.giftsList[i].state = 's3'
                    const [item] = state.giftsList.splice(i,1)
                    state.giftsList.push(item)
                    break;
                }
            }
        },

        
        SAVE_IMAGE(state, data) {
            state.saveImage = data
        },

    },
    actions: {
        setShareInfo({ commit }, data) {
            commit('UPDATE_SHARE_INFO', data)
        },

        setSystemPlans({ commit }, data) {
            commit('UPDATE_SYSTEM_PLANS', data)
        },

        setRecords({commit}, data) {
            commit('UPDATE_RECORDS', data)
        },

        setWithdrawnHistory({commit}, data) {
            commit('UPDATE_WITHDRAWN_HISTORY',data)
        },
        setGiftsList({commit}, data) {
            commit('UPDATE_GIFTS_LIST', data)
        },

        updateStateGift({commit}, data) {
            commit('UPDATE_STATE_GIFT',data)
        },

        setSaveImage({commit}, data) {
            commit('SAVE_IMAGE',data)
        },

    }
}

export default share
